<template>
  <billing-report-panel
    report-key="statement-check"
    route="/reports/billing-statement-check"
    file-name="conferencia-do-demonstrativo.xlsx"
    period-label="Período de fechamento do lote"
    :columns="columns"
    :status-options="statusOptions"
    show-status
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      statusOptions: ['analyzed', 'in_appeal', 'settled'],
      columns: [
        'Guia',
        'Paciente',
        'Informado',
        'Processado',
        'Liberado',
        'Glosado',
        'Pago',
        'Diferença entre informado e pago',
        'Situação da conferência',
        'Subtotal por lote',
      ],
    };
  },
};
</script>
